import React, { useState } from "react";
import "./App.css";
import Board from "./components/Board";
import "./styles/root.scss";
import { calculateWinner } from "./winnerCal";
import History from "./components/History";
import StatusMessage from "./components/StatusMessage";

function App() {
	// const [board, setBoard] = useState(Array(9).fill(null));
	// const [toMove, setMove] = useState(false);

	const [history, setHistory] = useState([
		{ board: Array(9).fill(null), toMove: true },
	]);
	const [moveIndex, setMoveIndex] = useState(0);

	const currentState = history[moveIndex];
	const { winner, winningSquares } = calculateWinner(currentState.board);

	const handleSquareClick = (position) => {
		if (currentState.board[position] || winner) return;

		setHistory((hist) => {
			const prevHist = hist[hist.length - 1];

			const newBoard = prevHist.board.map((el, index) => {
				if (index === position) return prevHist.toMove ? "X" : "O";
				else return el;
			});
			return hist.concat({ board: newBoard, toMove: !prevHist.toMove });
		});

		setMoveIndex((prevIndex) => prevIndex + 1);
	};

	const moveToHist = (move) => {
		setMoveIndex(move);
	};

	const startNewGame = () => {
		setHistory([{ board: Array(9).fill(null), toMove: true }]);
		setMoveIndex(0);
	};

	return (
		<div className="app">
			<h1>Tic Tac Toe</h1>
			<StatusMessage winner={winner} currentState={currentState} />
			<Board
				className="board"
				handleSquareClick={handleSquareClick}
				board={currentState.board}
				winningSquares={winningSquares}
			/>
			<button
				className={`btn-reset ${winner ? "active" : ""}`}
				type="button"
				onClick={startNewGame}
			>
				Start New Game!
			</button>
			<h2 style={{fontWeight : 'normal'}}>Current Game History</h2>
			<History
				moveIndex={moveIndex}
				history={history}
				moveToHist={moveToHist}
			/>
			<div className="bg-balls" />
		</div>
	);
}

export default App;
